<template>
	<div
		class="absolute inset-0"
		:class="[
			customColor,
			{
				'text-orange': color === 'orange',
				'text-pink-dark': color === 'red',
				'text-pink': color === 'pink',
				'text-blue': color === 'blue'
			}
		]"
	>
		<svg
			width="100%"
			height="100%"
			preserveAspectRatio="xMidYMid slice"
			viewBox="0 0 385 240"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			class="block object-cover"
		>
			<mask
				:id="`${prefix}_mask0_118_3146`"
				style="mask-type: alpha"
				maskUnits="userSpaceOnUse"
				x="0"
				y="0"
				width="385"
				height="240"
			>
				<rect
					x="385"
					y="240"
					width="385"
					height="240"
					transform="rotate(180 385 240)"
					:fill="`url(#${prefix}_paint0_radial_118_3146)`"
				/>
			</mask>
			<mask
				:id="`${prefix}_mask0_118_3146_anim`"
				style="mask-type: alpha"
				maskUnits="userSpaceOnUse"
				x="0"
				y="0"
				width="385"
				height="240"
				v-if="horizontal && animate"
			>
				<rect
					x="385"
					y="240"
					width="385"
					height="240"
					transform="rotate(180 385 240)"
					:fill="`url(#${prefix}_paint0_radial_118_3146_anim)`"
				/>
			</mask>
			<mask
				v-if="!horizontal && animate"
				:id="`${prefix}_mask0_118_3146_anim_2`"
				style="mask-type: alpha"
				maskUnits="userSpaceOnUse"
				x="0"
				y="0"
				width="385"
				height="240"
			>
				<rect
					x="385"
					y="240"
					width="385"
					height="240"
					transform="rotate(180 385 240)"
					:fill="`url(#${prefix}_paint0_radial_118_3146_anim_2)`"
				/>
			</mask>
			<g :mask="`url(#${prefix}_mask0_118_3146)`">
				<path
					opacity="0.05"
					d="M-65.3623 -73.4365H450.422V-71.8008H-65.3623V-73.4365ZM-65.3623 -65.6865H450.422V-64.0508H-65.3623V-65.6865ZM-65.3623 -57.9365H450.422V-56.3008H-65.3623V-57.9365ZM-65.3623 -50.1865H450.422V-48.5508H-65.3623V-50.1865ZM-65.3623 -42.4375H450.422V-40.8018H-65.3623V-42.4375ZM-65.3623 -34.6875H450.422V-33.0518H-65.3623V-34.6875ZM-65.3623 -26.9385H450.422V-25.3027H-65.3623V-26.9385ZM-65.3623 -19.1875H450.422V-17.5518H-65.3623V-19.1875ZM-65.3623 -11.4385H450.422V-9.80273H-65.3623V-11.4385ZM-65.3623 -3.68848H450.422V-2.05273H-65.3623V-3.68848ZM-65.3623 4.06152H450.422V5.69727H-65.3623V4.06152ZM-65.3623 11.8115H450.422V13.4473H-65.3623V11.8115ZM-65.3623 19.5605H450.422V21.1963H-65.3623V19.5605ZM-65.3623 27.3105H450.422V28.9463H-65.3623V27.3105ZM-65.3623 35.0596H450.422V36.6953H-65.3623V35.0596ZM-65.3623 42.8105H450.422V44.4463H-65.3623V42.8105ZM-65.3623 50.5596H450.422V52.1953H-65.3623V50.5596ZM-65.3623 58.3096H450.422V59.9453H-65.3623V58.3096ZM-65.3623 66.0596H450.422V67.6953H-65.3623V66.0596ZM-65.3623 73.8096H450.422V75.4453H-65.3623V73.8096ZM-65.3623 81.5586H450.422V83.1943H-65.3623V81.5586ZM-65.3623 89.3086H450.422V90.9443H-65.3623V89.3086ZM-65.3623 97.0586H450.422V98.6943H-65.3623V97.0586ZM-65.3623 104.809H450.422V106.444H-65.3623V104.809ZM-65.3623 112.558H450.422V114.193H-65.3623V112.558ZM-65.3623 120.308H450.422V121.943H-65.3623V120.308ZM-65.3623 128.058H450.422V129.693H-65.3623V128.058ZM-65.3623 135.808H450.422V137.443H-65.3623V135.808ZM-65.3623 143.557H450.422V145.192H-65.3623V143.557ZM-65.3623 151.307H450.422V152.942H-65.3623V151.307ZM-65.3623 159.057H450.422V160.692H-65.3623V159.057ZM-65.3623 166.808H450.422V168.443H-65.3623V166.808ZM-65.3623 174.557H450.422V176.192H-65.3623V174.557ZM-65.3623 182.307H450.422V183.942H-65.3623V182.307ZM-65.3623 190.057H450.422V191.692H-65.3623V190.057ZM-65.3623 197.807H450.422V199.442H-65.3623V197.807ZM-65.3623 205.556H450.422V207.191H-65.3623V205.556ZM-65.3623 213.306H450.422V214.941H-65.3623V213.306ZM-65.3623 221.056H450.422V222.691H-65.3623V221.056ZM-65.3623 228.806H450.422V230.441H-65.3623V228.806ZM-65.3623 236.555H450.422V238.19H-65.3623V236.555ZM-65.3623 244.305H450.422V245.94H-65.3623V244.305ZM-65.3623 252.055H450.422V253.69H-65.3623V252.055ZM-65.3623 259.805H450.422V261.44H-65.3623V259.805ZM-65.3623 267.554H450.422V269.189H-65.3623V267.554ZM-65.3623 275.304H450.422V276.939H-65.3623V275.304ZM-65.3623 283.054H450.422V284.689H-65.3623V283.054ZM-65.3623 290.804H450.422V292.439H-65.3623V290.804Z"
					fill="currentColor"
				/>
			</g>
			<g
				:mask="`url(#${prefix}_mask0_118_3146_anim)`"
				v-if="horizontal && animate"
			>
				<path
					opacity="0"
					d="M-65.3623 -73.4365H450.422V-71.8008H-65.3623V-73.4365ZM-65.3623 -65.6865H450.422V-64.0508H-65.3623V-65.6865ZM-65.3623 -57.9365H450.422V-56.3008H-65.3623V-57.9365ZM-65.3623 -50.1865H450.422V-48.5508H-65.3623V-50.1865ZM-65.3623 -42.4375H450.422V-40.8018H-65.3623V-42.4375ZM-65.3623 -34.6875H450.422V-33.0518H-65.3623V-34.6875ZM-65.3623 -26.9385H450.422V-25.3027H-65.3623V-26.9385ZM-65.3623 -19.1875H450.422V-17.5518H-65.3623V-19.1875ZM-65.3623 -11.4385H450.422V-9.80273H-65.3623V-11.4385ZM-65.3623 -3.68848H450.422V-2.05273H-65.3623V-3.68848ZM-65.3623 4.06152H450.422V5.69727H-65.3623V4.06152ZM-65.3623 11.8115H450.422V13.4473H-65.3623V11.8115ZM-65.3623 19.5605H450.422V21.1963H-65.3623V19.5605ZM-65.3623 27.3105H450.422V28.9463H-65.3623V27.3105ZM-65.3623 35.0596H450.422V36.6953H-65.3623V35.0596ZM-65.3623 42.8105H450.422V44.4463H-65.3623V42.8105ZM-65.3623 50.5596H450.422V52.1953H-65.3623V50.5596ZM-65.3623 58.3096H450.422V59.9453H-65.3623V58.3096ZM-65.3623 66.0596H450.422V67.6953H-65.3623V66.0596ZM-65.3623 73.8096H450.422V75.4453H-65.3623V73.8096ZM-65.3623 81.5586H450.422V83.1943H-65.3623V81.5586ZM-65.3623 89.3086H450.422V90.9443H-65.3623V89.3086ZM-65.3623 97.0586H450.422V98.6943H-65.3623V97.0586ZM-65.3623 104.809H450.422V106.444H-65.3623V104.809ZM-65.3623 112.558H450.422V114.193H-65.3623V112.558ZM-65.3623 120.308H450.422V121.943H-65.3623V120.308ZM-65.3623 128.058H450.422V129.693H-65.3623V128.058ZM-65.3623 135.808H450.422V137.443H-65.3623V135.808ZM-65.3623 143.557H450.422V145.192H-65.3623V143.557ZM-65.3623 151.307H450.422V152.942H-65.3623V151.307ZM-65.3623 159.057H450.422V160.692H-65.3623V159.057ZM-65.3623 166.808H450.422V168.443H-65.3623V166.808ZM-65.3623 174.557H450.422V176.192H-65.3623V174.557ZM-65.3623 182.307H450.422V183.942H-65.3623V182.307ZM-65.3623 190.057H450.422V191.692H-65.3623V190.057ZM-65.3623 197.807H450.422V199.442H-65.3623V197.807ZM-65.3623 205.556H450.422V207.191H-65.3623V205.556ZM-65.3623 213.306H450.422V214.941H-65.3623V213.306ZM-65.3623 221.056H450.422V222.691H-65.3623V221.056ZM-65.3623 228.806H450.422V230.441H-65.3623V228.806ZM-65.3623 236.555H450.422V238.19H-65.3623V236.555ZM-65.3623 244.305H450.422V245.94H-65.3623V244.305ZM-65.3623 252.055H450.422V253.69H-65.3623V252.055ZM-65.3623 259.805H450.422V261.44H-65.3623V259.805ZM-65.3623 267.554H450.422V269.189H-65.3623V267.554ZM-65.3623 275.304H450.422V276.939H-65.3623V275.304ZM-65.3623 283.054H450.422V284.689H-65.3623V283.054ZM-65.3623 290.804H450.422V292.439H-65.3623V290.804Z"
					fill="currentColor"
				>
					<animate
						attributeName="opacity"
						values="0; 0.5; 0"
						keyTimes="0; 0.5; 1"
						dur="1s"
						begin="0s"
						fill="freeze"
						repeatCount="1"
					/>
				</path>
			</g>
			<g
				:mask="`url(#${prefix}_mask0_118_3146_anim_2)`"
				v-if="!horizontal && animate"
			>
				<path
					opacity="1"
					d="M-65.3623 -73.4365H450.422V-71.8008H-65.3623V-73.4365ZM-65.3623 -65.6865H450.422V-64.0508H-65.3623V-65.6865ZM-65.3623 -57.9365H450.422V-56.3008H-65.3623V-57.9365ZM-65.3623 -50.1865H450.422V-48.5508H-65.3623V-50.1865ZM-65.3623 -42.4375H450.422V-40.8018H-65.3623V-42.4375ZM-65.3623 -34.6875H450.422V-33.0518H-65.3623V-34.6875ZM-65.3623 -26.9385H450.422V-25.3027H-65.3623V-26.9385ZM-65.3623 -19.1875H450.422V-17.5518H-65.3623V-19.1875ZM-65.3623 -11.4385H450.422V-9.80273H-65.3623V-11.4385ZM-65.3623 -3.68848H450.422V-2.05273H-65.3623V-3.68848ZM-65.3623 4.06152H450.422V5.69727H-65.3623V4.06152ZM-65.3623 11.8115H450.422V13.4473H-65.3623V11.8115ZM-65.3623 19.5605H450.422V21.1963H-65.3623V19.5605ZM-65.3623 27.3105H450.422V28.9463H-65.3623V27.3105ZM-65.3623 35.0596H450.422V36.6953H-65.3623V35.0596ZM-65.3623 42.8105H450.422V44.4463H-65.3623V42.8105ZM-65.3623 50.5596H450.422V52.1953H-65.3623V50.5596ZM-65.3623 58.3096H450.422V59.9453H-65.3623V58.3096ZM-65.3623 66.0596H450.422V67.6953H-65.3623V66.0596ZM-65.3623 73.8096H450.422V75.4453H-65.3623V73.8096ZM-65.3623 81.5586H450.422V83.1943H-65.3623V81.5586ZM-65.3623 89.3086H450.422V90.9443H-65.3623V89.3086ZM-65.3623 97.0586H450.422V98.6943H-65.3623V97.0586ZM-65.3623 104.809H450.422V106.444H-65.3623V104.809ZM-65.3623 112.558H450.422V114.193H-65.3623V112.558ZM-65.3623 120.308H450.422V121.943H-65.3623V120.308ZM-65.3623 128.058H450.422V129.693H-65.3623V128.058ZM-65.3623 135.808H450.422V137.443H-65.3623V135.808ZM-65.3623 143.557H450.422V145.192H-65.3623V143.557ZM-65.3623 151.307H450.422V152.942H-65.3623V151.307ZM-65.3623 159.057H450.422V160.692H-65.3623V159.057ZM-65.3623 166.808H450.422V168.443H-65.3623V166.808ZM-65.3623 174.557H450.422V176.192H-65.3623V174.557ZM-65.3623 182.307H450.422V183.942H-65.3623V182.307ZM-65.3623 190.057H450.422V191.692H-65.3623V190.057ZM-65.3623 197.807H450.422V199.442H-65.3623V197.807ZM-65.3623 205.556H450.422V207.191H-65.3623V205.556ZM-65.3623 213.306H450.422V214.941H-65.3623V213.306ZM-65.3623 221.056H450.422V222.691H-65.3623V221.056ZM-65.3623 228.806H450.422V230.441H-65.3623V228.806ZM-65.3623 236.555H450.422V238.19H-65.3623V236.555ZM-65.3623 244.305H450.422V245.94H-65.3623V244.305ZM-65.3623 252.055H450.422V253.69H-65.3623V252.055ZM-65.3623 259.805H450.422V261.44H-65.3623V259.805ZM-65.3623 267.554H450.422V269.189H-65.3623V267.554ZM-65.3623 275.304H450.422V276.939H-65.3623V275.304ZM-65.3623 283.054H450.422V284.689H-65.3623V283.054ZM-65.3623 290.804H450.422V292.439H-65.3623V290.804Z"
					fill="currentColor"
				>
					<animate
						attributeName="opacity"
						values="0; 0.5; 0"
						keyTimes="0; 0.5; 1"
						dur="1s"
						begin="0s"
						fill="freeze"
						repeatCount="1"
					/>
				</path>
			</g>
			<defs>
				<radialGradient
					:id="`${prefix}_paint0_radial_118_3146`"
					cx="0"
					cy="0"
					r="1"
					gradientUnits="userSpaceOnUse"
					gradientTransform="translate(577.5 360) rotate(180) scale(272.5 144.001)"
				>
					<stop offset="0.509906" stop-color="#33567F" stop-opacity="0" />
					<stop offset="0.897053" stop-color="#0A1119" />
					<stop offset="1" stop-color="#142232" stop-opacity="0" />
				</radialGradient>
				<linearGradient
					:id="`${prefix}_paint0_radial_118_3146_anim_2`"
					x1="50%"
					x2="50%"
					y1="50"
					y2="50%"
					v-if="!horizontal && animate"
				>
					<stop offset="0" stop-color="#fff" stop-opacity="0" />
					<stop offset="0.1" stop-color="#fff" stop-opacity="0" />
					<stop offset="0.2" stop-color="#fff" stop-opacity="1" />
					<stop offset="0.37" stop-color="#fff" stop-opacity="0" />
					<stop offset="0.4" stop-color="#fff" stop-opacity="1" />
					<stop offset="0.5" stop-color="#fff" stop-opacity="0" />
					<stop offset="0.6" stop-color="#fff" stop-opacity="1" />
					<stop offset="0.63" stop-color="#fff" stop-opacity="0" />
					<stop offset="0.8" stop-color="#fff" stop-opacity="1" />
					<stop offset="0.9" stop-color="#fff" stop-opacity="0" />
					<stop offset="1" stop-color="#fff" stop-opacity="0" />
					<animate
						attributeName="y1"
						from="50%"
						to="-200%"
						dur="1s"
						begin="0s"
						fill="freeze"
					/>
					<animate
						attributeName="y2"
						from="50%"
						to="300%"
						dur="1s"
						begin="0s"
						fill="freeze"
					/>
				</linearGradient>
				<radialGradient
					:id="`${prefix}_paint0_radial_118_3146_anim`"
					cx="0"
					cy="0"
					r="1"
					gradientUnits="userSpaceOnUse"
					gradientTransform="translate(577.5 360) rotate(180) scale(272.5 144.001)"
					v-if="horizontal && animate"
				>
					<stop offset="0.1" stop-color="#fff" stop-opacity="1" />
					<stop offset="0.2" stop-color="#fff" stop-opacity="0" />
					<stop offset="0.3" stop-color="#fff" stop-opacity="1" />
					<stop offset="0.4" stop-color="#fff" stop-opacity="0" />
					<stop offset="0.5" stop-color="#fff" stop-opacity="1" />
					<stop offset="0.6" stop-color="#fff" stop-opacity="0" />
					<stop offset="0.7" stop-color="#fff" stop-opacity="1" />
					<stop offset="0.8" stop-color="#fff" stop-opacity="0" />
					<stop offset="1" stop-color="#fff" stop-opacity="1" />
					<animate
						attributeName="r"
						from="1"
						to="6"
						dur="1s"
						begin="0s"
						fill="freeze"
					/>
				</radialGradient>
			</defs>
		</svg>
	</div>
</template>
<script setup lang="ts">
defineProps<{
	color: 'orange' | 'red' | 'pink' | 'blue'
	customColor?: string
	horizontal?: boolean
	animate?: boolean
	prefix: string
}>()
</script>
